import { Circle, Group, Image as KonvaImage } from "react-konva";
import useImage from "use-image";

export const colors: Record<string, string> = {
  red: "#FF0044",
  blue: "#006CFE",
  yellow: "#FFCC41",
  purple: "#B476FB",
  orange: "#FE9D24",
  green: "#29B278",
  teal: "#00D7BF",
};

interface TrackPinProps {
  animalName: string | undefined;
  x: number;
  y: number;
  size: number;
  color: string | undefined;
  isLoading: boolean;
  isHighlighted?: boolean;
}

const TrackPin = ({
  animalName,
  x,
  y,
  size,
  color,
  isLoading,
  isHighlighted = false,
}: TrackPinProps) => {
  const [image] = useImage(`/assets/images/animals/${animalName}.png`);

  return (
    <Group opacity={isLoading ? 0.5 : 1}>
      <Circle
        x={x}
        y={y}
        radius={isHighlighted ? size / 2 + 6 : size / 2 + 4}
        fill={colors[color || "red"]}
        stroke="white"
        strokeWidth={4}
        strokeEnabled={isHighlighted}
      />
      <KonvaImage
        x={x - size / 2}
        y={y - size / 2}
        image={image}
        width={size}
        height={size}
      />
    </Group>
  );
};

export default TrackPin;
